import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { IModel } from 'shell-models-lib';
import {
    SqlServerLinkedServiceAdapter,
    sqlServerLinkedServiceAdapts
} from 'app/model/adapters/linkedservices/sql-server-linkedservice.adapter';
import { AmazonRdsSqlServerLinkedService } from 'app/model/linkedservice/amazon-rds-sql-server.linkedservice';

// the same as SqlServerLinkedServiceAdapter
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRdsSqlServerLinkedService),
    asynchronous: true,
    adapts: sqlServerLinkedServiceAdapts
})
export class AmazonRdsSqlServerLinkedServiceAdapter extends SqlServerLinkedServiceAdapter {
    protected modelConstructor(): new () => AmazonRdsSqlServerLinkedService {
        return AmazonRdsSqlServerLinkedService;
    }

    protected model(): IModel {
        return AmazonRdsSqlServerLinkedService.MODEL;
    }
}
